import { RestCallsService } from './../rest-calls.service';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, LoadingController } from '@ionic/angular';
import { Validators, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'contact.modal.page',
  templateUrl: './contact.modal.page.html',
  styleUrls: ['./contact.modal.page.scss'],
})
export class ContactModalPage implements OnInit {
  customer: any;
  loader: any;
  validation_messages = {
    'name': [
      { type: 'required', message: 'Name is required.' },
      { type: 'minlength', message: 'Name must be at least 5 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name should contain only numbers and letters.' },
    ],
    'email': [
      { type: 'required', message: 'Email is required.' },
      { type: 'pattern', message: 'Enter a valid email.' }
    ],
    'address': [
      { type: 'required', message: 'Address is required.' },
      { type: 'minlength', message: 'Min length is 5' },
      { type: 'maxlength', message: 'Man length is 100' }
    ],
    'phone': [
      { type: 'required', message: 'Phone is required.' },
      { type: 'minlength', message: 'length should be 10' },
      { type: 'maxlength', message: 'Man length is 10' }
    ],
  };
  validations_form: FormGroup = new FormGroup({
    name: new FormControl('', Validators.compose([
      Validators.maxLength(100),
      Validators.minLength(5),
      Validators.required
    ])),
    email: new FormControl('', Validators.compose([
      Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
    ])),
    phone: new FormControl('', Validators.compose([
      Validators.maxLength(10),
    ])),
    address: new FormControl('', Validators.compose([
      Validators.maxLength(100),
    ])),
  });
  form: FormGroup;
  index: any;
  newCustomer: boolean;

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private loadingCtrl: LoadingController,
    private restApi: RestCallsService,
  ) { }

  ngOnInit() {
    console.table(this.navParams);
    this.customer = this.navParams.data.contact;
    this.validations_form.controls['name'].setValue(this.customer.name);
    this.validations_form.controls['email'].setValue(this.customer.email);
    this.validations_form.controls['phone'].setValue(this.customer.phone);
    this.validations_form.controls['address'].setValue(this.customer.address);
    this.index = this.navParams.data.index;
    this.newCustomer = this.navParams.data.new;
  }

  async presentLoading(msg) {
    this.loader = await this.loadingCtrl.create({
      message: msg
    });
    console.log(1);
    return await this.loader.present();
  }
  // closeModal() {
  //   this.modalController.dismiss(this.customer);
  // }
  done() {
    this.customer.name = this.validations_form.get('name').value;
    this.customer.email = this.validations_form.get('email').value;
    this.customer.address = this.validations_form.get('address').value;
    this.customer.phone = this.validations_form.get('phone').value;

    if (this.newCustomer) {
      this.modalController.dismiss({
        contact: this.customer,
        index: this.index
      });
    } else {
      this.presentLoading('Adding...');
      if ( this.customer.id === -1 || this.customer.id === '') {
        this.restApi.addCustomerContact(this.customer).subscribe( (res: any) => {
          console.log(res);
          this.loader.dismiss();
          if (res.success) {
            this.customer.id = res.data.id;
            this.modalController.dismiss({
              contact: this.customer,
              index: this.index
            });
          } else {
            alert('Failed to add');
          }
        });
      } else {
        this.customer.contact_num = this.customer.phone;
        this.restApi.updateCustomerContact(this.customer).subscribe( (res: any) => {
          console.log(res);
          this.loader.dismiss();
          if (res.success) {
            this.customer.id = res.data[0].id;
            this.modalController.dismiss({
              contact: this.customer,
              index: this.index
            });
          } else {
            alert('Failed to update');
          }
        });
      }
    }
  }
  back() {
    this.modalController.dismiss(null);
  }
}
